import makeStyles from "@mui/styles/makeStyles";

const styles = makeStyles((theme) => ({
  title: {
    fontFamily: "Manrope",
    fontSize: "18px",
    fontWeight: 700,
    color: "#465869",
    lineHeight: "18px",
  },

  button: {
    marginRight: "10px",
  },

  icon: {
    fontSize: "16px",
    marginLeft: "5px",
  },

  formContainer: {
    border: "1px solid #93A9BD",
    borderRadius: "0 0 5px 5px",
    marginTop: "-1px",
    background: "#F8FAFC",
  },

  formContent: {
    alignSelf: "flex-start",
    alignItems: "center",
    padding: "15px !important",
  },

  sameAsPostal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  buttonSave: {
    marginRight: "10px",
  },

  deleteContactIconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginBottom: "-25px",
  },

  addAnotherContact: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    cursor: "pointer",
  },

  formLabel: {
    fontSize: "14px",
    lineHeight: "18px",
    fontWeight: "bold",
    color: "#465869",
  },

  statusContent: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    top: 20,
    right: 16,
  },

  textStatus: {
    color: "#465869",
    fontSize: "12px",
    fontWeight: 700,
  },

  checkboxText: {
    fontSize: "12px",
    lineHeight: "16px",
    color: "#465869",
  },

  loading: {
    position: "absolute",
    top: "0",
    left: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    background: "#FFF",
    zIndex: 1000,
  },

  deleteModalWidth: {
    width: "520px",
  },
  deleteModalDescription: {
    marginBottom: "16px",
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: "#465869",
  },
  deleteModalDescriptionConfirm: {
    color: "#F04438",
    fontStyle: "italic",
  },
}));

export default styles;
